import React, { FC, FormEvent, useState } from 'react'
import { Dialog } from 'components/Dialog'
import { Stack } from 'components/Stack'
import { useTranslation } from 'react-i18next'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { TextInput } from 'components/TextInput'
import { Button } from 'components/Button'
import { Project } from 'models/project'

type ProjectNameDialogProps = {
  name: string
  isOpen: boolean
  onClose: () => void
  onConfirm: (data: Pick<Project, 'name'>) => Promise<Project>
}

export const ProjectNameDialog: FC<ProjectNameDialogProps> = ({
  onClose,
  onConfirm,
  isOpen,
  ...props
}) => {
  const { t } = useTranslation()
  const [name, setName] = useState(props.name)

  const onSubmit = (event: FormEvent) => {
    event.preventDefault()
    onConfirm({ name }).then(() => onClose())
  }

  return (
    <Dialog aria-label={t(`project_name_dialog.title`)} isOpen={isOpen} onClose={onClose}>
      <Stack space="medium">
        <Stack space="small">
          <Heading>{t('project_name_dialog.title')}</Heading>
          <Text>{t('project_name_dialog.desc')}</Text>
        </Stack>

        <form onSubmit={onSubmit}>
          <Stack space="medium">
            <TextInput
              name="name"
              label={t('project_name_dialog.form.name')}
              onChange={(event) => setName(event.target.value)}
              value={name}
            />
            <Button type="submit" loading={false} full>
              {t('project_name_dialog.cta')}
            </Button>
          </Stack>
        </form>
      </Stack>
    </Dialog>
  )
}

ProjectNameDialog.displayName = 'ProjectNameDialog'
